export default {
  list: [
    {
      value: 'ADD_NEW_CAFE',
      title: 'ثبت کافه جدید',
    },
    {
      value: 'EDIT_CAFE',
      title: 'ویرایش کافه',
    },
    {
      value: 'VIEW_CAFES_LIST',
      title: 'مشاهده لیست کافه‌ها',
    },
    {
      value: 'VIEW_ONLINE_PAYMENTS_REPORT',
      title: 'مشاهده گزارش پرداخت‌ها از طریق درگاه بانکی',
    },
    {
      value: 'VIEW_FINANCIAL_TRANSACTIONS_REPORT',
      title: 'مشاهده گزارش گردش حساب اعتبار مشتری‌ها',
    },
    {
      value: 'VIEW_USERS_LIST',
      title: 'مشاهده لیست کاربرها',
    },
    {
      value: 'ADD_NEW_USER',
      title: 'ثبت کاربر جدید',
    },
    {
      value: 'EDIT_USER',
      title: 'ویرایش کاربر',
    },
    {
      value: 'VIEW_USER_INFO',
      title: 'مشاهده اطلاعات کامل کاربر',
    },
    {
      value: 'VIEW_MY_CAFE_INFO',
      title: 'مشاهده اطلاعات کافه من',
    },
    {
      value: 'EDIT_MY_CAFE_INFO',
      title: 'ویرایش اطلاعات کافه من',
    },
    {
      value: 'VIEW_USERS_COMMENTS_LIST',
      title: 'مشاهده لیست نظرهای کاربرها',
    },
    {
      value: 'VIEW_SYSTEM_SETTINGS',
      title: 'مشاهده تنظیمات سیستمی',
    },
    {
      value: 'VIEW_INTRODUCED_CAFES_LIST',
      title: 'مشاهده لیست کافه‌های معرفی‌شده',
    },
    {
      value: 'VIEW_MY_CAFE_RESERVE_LIST',
      title: 'رزروهای کافه من',
    },
    {
      value: 'VIEW_ALL_CAFE_RESERVE_LIST',
      title: 'مشاهده رزروهای همه کافه‌ها',
    },
    {
      value: 'REPLY_USERS_COMMENTS',
      title: 'جواب نظرهای کاربرها',
    },

    {
      value: 'VIEW_CAFE_FACTOR_ADDITIONS_LIST',
      title: 'مشاهده اضافات فاکتوز',
    },
    {
      value: 'VIEW_CAFE_FACTOR_DEDUCTIONS_LIST',
      title: 'مشاهده لیست کسورات فاکتور',
    },
    {
      value: 'ACTIVE_INACTIVE_CAFE_FACTOR_ADDITION',
      title: 'فعال/غیرفعال اضافه فاکتور',
    },
    {
      value: 'DELETE_CAFE_FACTOR_ADDITION',
      title: 'حذف اضافه فاکتور',
    },
    {
      value: 'ADD_NEW_CAFE_FACTOR_ADDITION',
      title: 'ثبت اضافه فاکتور جدید',
    },
    {
      value: 'ACTIVE_INACTIVE_CAFE_FACTOR_DEDUCTION',
      title: 'فعال/غیرفعال کسر فاکتور',
    },
    {
      value: 'DELETE_CAFE_FACTOR_DEDUCTION',
      title: 'حذف کسر فاکتور',
    },
    {
      value: 'ADD_NEW_CAFE_FACTOR_DEDUCTION',
      title: 'ثبت کسر فاکتور جدید',
    },

    {
      value: 'VIEW_MENU_CATEGORIES_LIST',
      title: 'مشاهده لیست دسته‌بندی منوها',
    },
    {
      value: 'VIEW_DELETED_MENU_CATEGORIES_LIST',
      title: 'مشاهده لیست دسته‌بندی منوهای حذف شده',
    },
    {
      value: 'VIEW_MENU_CATEGORY_DETAILS',
      title: 'مشاهده جزئیات دسته‌بندی منو',
    },
    {
      value: 'ADD_NEW_MENU_CATEGORY',
      title: 'ثبت دسته‌بندی منو جدید',
    },
    {
      value: 'ACTIVE_INACTIVE_MENU_CATEGORY',
      title: 'فعال/غیرفعال دسته‌بندی منو',
    },
    {
      value: 'EDIT_MENU_CATEGORY',
      title: 'ویرایش دسته‌بندی منو',
    },
    {
      value: 'DELETE_MENU_CATEGORY',
      title: 'حذف دسته‌بندی منو',
    },

    {
      value: 'VIEW_MENU_ITEMS_LIST',
      title: 'مشاهده لیست آیتم‌های منو',
    },
    {
      value: 'VIEW_DELETED_MENU_ITEMS_LIST',
      title: 'مشاهده لیست آیتم‌های منوی حذف شده',
    },
    {
      value: 'VIEW_MENU_ITEM_DETAILS',
      title: 'مشاهده جزئیات آیتم منو',
    },
    {
      value: 'ADD_NEW_MENU_ITEM',
      title: 'ثبت آیتم منو جدید',
    },
    {
      value: 'EDIT_MENU_ITEM',
      title: 'ویرایش آیتم منو',
    },
    {
      value: 'DELETE_MENU_ITEM',
      title: 'حذف آیتم منو',
    },
    {
      value: 'EDIT_COMMENT',
      title: 'ویرایش نظر',
    },
    {
      value: 'EDIT_MESSAGE',
      title: 'ویرایش پیام',
    },
    {
      value: 'SEND_NEW_MESSAGE',
      title: 'ارسال پیام جدید',
    },

    {
      value: 'VIEW_MESSAGES_LIST',
      title: 'مشاهده لیست پیام ها',
    },
    {
      value: 'VIEW_MESSAGE_DETAILS',
      title: 'مشاهده جزئیات پیام',
    },

    {
      value: 'VIEW_CAFE_TIME_SLICES_LIST',
      title: 'مشاهده لیست ساعت‌های رزرو',
    },
    {
      value: 'ADD_NEW_CAFE_TIME_SLICE',
      title: 'ثبت ساعت رزرو جدید',
    },
    {
      value: 'VIEW_CAFE_TABLES_LIST',
      title: 'مشاهده لیست میزهای کافه',
    },

    {
      value: 'VIEW_CAFE_DATES_LIST',
      title: 'مشاهده لیست روزهای رزرو',
    },
    {
      value: 'ADD_NEW_CAFE_DATE',
      title: 'ثبت روز رزرو جدید',
    },

    {
      value: 'VIEW_CAFE_DATE_DETAILS',
      title: 'مشاهده جزئیات روز رزرو',
    },
    {
      value: 'EDIT_STATUS_CAFE_DATE',
      title: 'ویرایش وضعیت روز رزرو',
    },
    {
      value: 'DELETE_CAFE_DATE',
      title: 'حذف روز رزرو',
    },

    {
      value: 'VIEW_CAFE_TIME_SLICE_DETAILS',
      title: 'مشاهده جزئیات ساعت رزرو',
    },
    {
      value: 'EDIT_CAFE_TIME_SLICE',
      title: 'ویرایش ساعت رزرو',
    },
    {
      value: 'DELETE_CAFE_TIME_SLICE',
      title: 'حذف ساعت رزرو',
    },
    {
      value: 'EDIT_CAFE_DATE',
      title: 'ویرایش روز رزرو',
    },

    {
      value: 'VIEW_RESERVES_LIST',
      title: 'مشاهده لیست رزروها',
    },
    {
      value: 'VIEW_RESERVES_SCHEMATIC_LIST',
      title: 'مشاهده لیست شماتیک رزروها',
    },
    {
      value: 'VIEW_RESERVE_DETAILS',
      title: 'مشاهده جزئیات رزرو',
    },
    {
      value: 'EDIT_STATUS_RESERVE',
      title: 'ویرایش وضعیت رزرو',
    },
    {
      value: 'VIEW_INVOICE_DETAILS',
      title: 'مشاهده جزئیات فاکتور',
    },
    {
      value: 'EDIT_INVOICE',
      title: 'ویرایش فاکتور',
    },

    {
      value: 'ADD_NEW_CAFE_USER',
      title: 'انتساب کاربر به کافه',
    },
    {
      value: 'VIEW_CAFE_USER_DETAILS',
      title: 'مشاهده جزئیات کاربرهای کافه',
    },
    {
      value: 'EDIT_CAFE_USER',
      title: 'ویرایش کاربر کافه',
    },
    {
      value: 'DELETE_CAFE_USER',
      title: 'حذف کاربر کافه',
    },

    {
      value: 'VIEW_ADMIN_DASHBOARD_REPORTS',
      title: 'مشاهده گزارش‌های داشبورد مدیرسیستم',
    },

    {
      value: 'VIEW_DISCOUNT_CODES_LIST',
      title: 'مشاهده لیست کد تخفیف',
    },
    {
      value: 'ADD_NEW_DISCOUNT_CODE',
      title: 'ثبت کد تخفیف جدید',
    },
    {
      value: 'VIEW_DISCOUNT_CODE_DETAILS',
      title: 'مشاهده جزئیات کد تخفیف',
    },
    {
      value: 'EDIT_STATUS_DISCOUNT_CODE',
      title: 'ویرایش وضعیت کد تخفیف',
    },
    {
      value: 'EDIT_DISCOUNT_CODE',
      title: 'ویرایش کد تخفیف',
    },
    {
      value: 'AUTO_GENERATE_RESERVE_DATES_AND_HOURS',
      title: 'تولید خودکار روزها و ساعت‌های رزرو',
    },

    {
      value: 'VIEW_TICKETS_LIST',
      title: 'مشاهده لیست تیکت‌ها',
    },
    {
      value: 'VIEW_TICKET_DETAILS',
      title: 'مشاهده جزئیات تیکت',
    },

    {
      value: 'VIEW_MY_CAFE_WORKING_HOURS',
      title: 'مشاهده ساعت‌های کاری کافه من',
    },
    {
      value: 'VIEW_MY_CAFE_DISCOUNTS_LIST',
      title: 'لیست تخفیف‌های کافه من',
    },
    {
      value: 'ADD_NEW_CAFE_DISCOUNT_REQUEST',
      title: 'ایجاد درخواست تخفیف جدید برای کافه من',
    },
    {
      value: 'VIEW_ROLES_LIST',
      title: 'مشاهده لیست نقش‌ها',
    },

    {
      value: 'EDIT_CAFE_FOR_CAFE_ADMIN',
      title: 'ویرایش کافه برای مدیر کافه',
    },
    {
      value: 'VIEW_CAFE_FOR_CAFE_ADMIN_DETAILS',
      title: 'مشاهده جزئیات کافه برای مدیر کافه',
    },

    {
      value: 'UPLOAD_CAFE_IMAGES',
      title: 'آپلود تصاویر کافه',
    },

    {
      value: 'VIEW_CAFE_DATES_LIST_FOR_ADMIN',
      title: 'مشاهده لیست روزهای رزرو برای مدیر کافه',
    },

    {
      value: 'VIEW_AHEAD_RESERVES_FOR_ADMIN',
      title: 'نمایش رزروهای پیش‌رو برای مدیرآرسی',
    },
    {
      value: 'VIEW_REQUESTS_RESERVES_FOR_ADMIN',
      title: 'نمایش رزروهای درخواست شده برای مدیرآرسی',
    },

    {
      value: 'VIEW_ARCHIVE_RESERVES_FOR_ADMIN',
      title: 'نمایش گزارش رزروها برای مدیرآرسی',
    },

    {
      value: 'VIEW_CAFE_DISCOUNTS_REQUESTED_LIST',
      title: 'مشاهده درخواست‌های تخفیف کافه‌ها',
    },
    {
      value: 'VIEW_CAFE_DISCOUNTS_ARCHIVED_LIST',
      title: 'مشاهده آرشیوهای تخفیف‌ کافه‌ها',
    },
    {
      value: 'CONFIRM_CAFE_DISCOUNT',
      title: 'تایید تخفیف کافه',
    },
    {
      value: 'REJECT_CAFE_DISCOUNT',
      title: 'رد کردن تخفیف کافه',
    },

    {
      value: 'VIEW_CAFE_WORKING_HOURS',
      title: 'مشاهده ساعت‌های کاری هر کافه‌',
    },
    {
      value: 'VIEW_RSEE_DISCOUNTS_LIST',
      title: 'لیست تخفیف‌های آرسی',
    },
    {
      value: 'ADD_NEW_RSEE_DISCOUNT',
      title: 'ایجاد تخفیف آرسی جدید',
    },
    {
      value: 'CONFIRM_RSEE_DISCOUNT',
      title: 'تایید تخفیف آرسی',
    },

    {
      value: 'VIEW_CAFE_ADMIN_DASHBOARD_REPORTS',
      title: 'مشاهده گزارش‌های داشبورد مدیر کافه',
    },
    {
      value: 'VIEW_MY_CAFE_EVENTS_LIST',
      title: 'لیست رویدادهای کافه من',
    },
    {
      value: 'ADD_NEW_CAFE_EVENT_REQUEST',
      title: 'ایجاد درخواست رویداد جدید برای کافه من',
    },
    {
      value: 'EDIT_CAFE_EVENT_REQUEST',
      title: 'ویرایش درخواست رویداد برای کافه من',
    },
    {
      value: 'VIEW_CAFE_EVENT_DETAILS',
      title: 'مشاهده جزئیات رویداد کافه',
    },
    {
      value: 'VIEW_CAFE_EVENTS_REQUESTED_LIST',
      title: 'مشاهده درخواست‌های رویداد کافه‌ها',
    },
    {
      value: 'VIEW_CAFE_EVENTS_ARCHIVED_LIST',
      title: 'مشاهده آرشیوهای رویداد کافه‌ها',
    },
    {
      value: 'CONFIRM_CAFE_EVENT',
      title: 'تایید رویداد کافه',
    },
    {
      value: 'REJECT_CAFE_EVENT',
      title: 'رد کردن رویداد کافه',
    },
    {
      value: 'DISABLE_CAFE_EVENT',
      title: 'غیرفعال کردن رویداد کافه',
    },

    {
      value: 'VIEW_RESERVES_READY_TO_CHECKOUT_LIST',
      title: 'مشاهده لیست رزروهای پایان یافته و عدم مراجعه',
    },
    {
      value: 'VIEW_RESERVES_RELATED_TO_CAFE_FOR_CHECKOUT_LIST',
      title: 'رزروهای مرتبط با کافه برای تسویه حساب',
    },
    {
      value: 'VIEW_CHECKOUTS_WITH_CAFE_LIST_ARCHIVES',
      title: 'مشاهده لیست آرشیو تسویه حساب‌ها',
    },
    {
      value: 'VIEW_RESERVES_RELATED_TO_CHECKOUT_WITH_CAFE_LIST',
      title: 'رزروهای مرتبط با آرشیو تسویه حساب ها',
    },
    {
      value: 'CHECKOUT_WITH_CAFE',
      title: 'تسویه حساب',
    },
    {
      value: 'NEW_CHECKOUT_WITH_CAFE',
      title: 'تسویه حساب جدید',
    },
    {
      value: 'VIEW_CHECKOUTS_WITH_CAFE_LIST',
      title: 'مشاهده لیست تسویه حساب‌ها',
    },
    {
      value: 'VIEW_CHECKOUT_WITH_CAFE_DETAILS',
      title: 'مشاهده جزئیات یک تسویه حساب',
    },
    {
      value: 'VIEW_ADS_LIST',
      title: 'مشاهده لیست تبلیغ‌ها',
    },
    {
      value: 'NEW_AD',
      title: 'ایجاد تبلیغ جدید',
    },
    {
      value: 'UPDATE_IS_VISIBLE_AD',
      title: 'ویرایش قابل نمایش تبلیغ',
    },
    {
      value: 'DELETE_AD',
      title: 'حذف تبلیغ',
    },
    {
      value: 'VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN',
      title: 'مشاهده لیست تسویه حساب‌ها برای مدیر آرسی',
    },
    {
      value: 'VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_CAFE_ADMIN',
      title: 'مشاهده لیست تسویه حساب‌ها برای مدیر کافه',
    },
    {
      value: 'AUTO_GENERATE_RESERVE_DATES_AND_HOURS_FOR_ALL_CAFES',
      title: 'تولید خودکار روزها و ساعت‌های رزرو همه کافه‌ها',
    },
    {
      value: 'REPLY_COMMENT_BY_RSEE_USER',
      title: 'پاسخ به نظر توسط کاربر آرسی',
    },
    {
      value: 'REPLY_COMMENT_BY_CAFE_USER',
      title: 'پاسخ به نظر توسط کاربر کافه',
    },
    {
      value: 'CONFIRM_OR_REJECT_COMMENT',
      title: 'تایید یا رد نظر',
    },
    {
      value: 'VIEW_USER_MOBILE_NUMBER',
      title: 'مشاهده شماره موبایل کاربر',
    },
    {
      value: 'SEARCH_CAFE_NAMES',
      title: 'جستجوی نام کافه‌ها',
    },
    {
      value: 'UPDATE_IS_DEFAULT_AD',
      title: 'ویرایش تبلیغ پیش فرض',
    },
    {
      value: 'VIEW_CAFE_CONTRACTS_LIST',
      title: 'نمایش لیست قراردها',
    },
    {
      value: 'CAFE_CONTRACTS_CAFES_LIST',
      title: 'نمایش لیست کافه های موجود در قراردادها',
    },
    {
      value: 'VIEW_CAFE_CONTRACT_DETAILS',
      title: 'جزيیات قرارداد',
    },
    {
      value: 'NEW_CAFE_CONTRACT',
      title: 'ایجاد قرارداد جدید',
    },
    {
      value: 'UPDATE_CAFE_CONTRACT',
      title: 'ویرایش قرارداد',
    },
    {
      value: 'SALES_REPORT',
      title: 'گزارش میزان فروش',
    },
    {
      value: 'VIEW_PRINTERS_LIST',
      title: 'لیست پرینترها',
    },
    {
      value: 'UPDATE_PRINTER',
      title: 'ویرایش پرینتر'
    },
    {
      value: 'VIEW_PRINTER_DETAILS',
      title: 'مشاهده جزییات یک پرینتر'
    },
    {
      value: 'VIEW_CAFE_SCHEDULES_LIST',
      title: 'مشاهده لیست زمانبندی های کافه',
    },
    {
      value: 'ADD_NEW_CAFE_SCHEDULE',
      title: 'ثبت زمانبندی جدید',
    },
    {
      value: 'VIEW_CAFE_SCHEDULE_DETAILS',
      title: 'مشاهده جزئیات زمانبندی',
    },
    {
      value: 'EDIT_CAFE_SCHEDULE',
      title: 'ویرایش زمانبندی',
    },
    {
      value: 'DELETE_CAFE_SCHEDULE',
      title: 'حذف زمانبندی',
    },
    {
      value: 'VIEW_REPORT_OF_COMPLETED_RESERVES_AND_NO_VISITS',
      title: 'نمایش گزارش رزوهای پایان یافته و عدم مراجعه مشتری',
    },
    {
      value: 'VIEW_TAKEAWAY_FACTORS_LIST',
      title: 'لیست فاکتور ها برای ادمین آرسی',
    },
    {
      value: 'ADD_NEW_RSEE_PACKAGE',
      title: 'ثبت بسته جدید',
    },
    {
      value: 'VIEW_RSEE_PACKAGES_LIST',
      title: 'مشاهده لیست بسته ها',
    },
    {
      value: 'VIEW_RSEE_PACKAGE_DETAILS',
      title: 'مشاهده جزئیات بسته',
    },
    {
      value: 'EDIT_RSEE_PACKAGE',
      title: 'ویرایش بسته',
    },
    {
      value: 'EDIT_RSEE_PACKAGE_STATUS',
      title: 'ویرایش وضعیت بسته',
    },
    {
      value: 'VIEW_RSEE_PACKAGES_SALES_REPORT',
      title: 'مشاهده گزارش بسته ها',
    },
    {
      value: 'VIEW_CONSTANT_RESERVES_REPORT',
      title: 'مشاهده گزارش رزرو ها با مبلغ ثابت',
    },
    {
      value: 'VIEW_RECHARGE_CHAIRS_REPORT',
      title: 'مشاهده گزارش شارژ صندلی',
    },
    {
      value: 'ADD_GIFT_CHAIR',
      title: 'ثبت صندلی هدیه',
    },
    {
      value: 'VIEW_CITIES_LIST',
      title: 'مشاهده لیست شهر ها'
    },
    {
      value: 'ADD_NEW_CITY',
      title: 'اضافه کردن شهر جدید'
    },
    {
      value: 'VIEW_CITY_DETAILS',
      title: 'نمایش جزییات شهر'
    },
    {
      value: 'EDIT_CITY',
      title: 'ویرایش شهر'
    },
    {
      value: 'VIEW_REGIONS_LIST',
      title: 'مشاهده لیست منطقه ها'
    },
    {
      value: 'ADD_NEW_REGION',
      title: 'اضافه کردن منطقه جدید'
    },
    {
      value: 'VIEW_REGION_DETAILS',
      title: 'نمایش جزییات منطقه'
    },
    {
      value: 'EDIT_REGION',
      title: 'ویرایش منطقه'
    }
  ],
  values: {
    ADD_NEW_CAFE: 'ADD_NEW_CAFE',
    EDIT_CAFE: 'EDIT_CAFE',
    VIEW_CAFES_LIST: 'VIEW_CAFES_LIST',
    VIEW_ONLINE_PAYMENTS_REPORT: 'VIEW_ONLINE_PAYMENTS_REPORT',
    VIEW_FINANCIAL_TRANSACTIONS_REPORT: 'VIEW_FINANCIAL_TRANSACTIONS_REPORT',
    VIEW_USERS_LIST: 'VIEW_USERS_LIST',
    ADD_NEW_USER: 'ADD_NEW_USER',
    EDIT_USER: 'EDIT_USER',
    VIEW_USER_INFO: 'VIEW_USER_INFO',
    VIEW_MY_CAFE_INFO: 'VIEW_MY_CAFE_INFO',
    EDIT_MY_CAFE_INFO: 'EDIT_MY_CAFE_INFO',
    VIEW_USERS_COMMENTS_LIST: 'VIEW_USERS_COMMENTS_LIST',
    VIEW_SYSTEM_SETTINGS: 'VIEW_SYSTEM_SETTINGS',
    VIEW_INTRODUCED_CAFES_LIST: 'VIEW_INTRODUCED_CAFES_LIST',
    VIEW_MY_CAFE_RESERVE_LIST: 'VIEW_MY_CAFE_RESERVE_LIST',
    VIEW_ALL_CAFE_RESERVE_LIST: 'VIEW_ALL_CAFE_RESERVE_LIST',
    REPLY_USERS_COMMENTS: 'REPLY_USERS_COMMENTS',
    VIEW_CAFE_FACTOR_ADDITIONS_LIST: 'VIEW_CAFE_FACTOR_ADDITIONS_LIST',
    VIEW_CAFE_FACTOR_DEDUCTIONS_LIST: 'VIEW_CAFE_FACTOR_DEDUCTIONS_LIST',
    ACTIVE_INACTIVE_CAFE_FACTOR_ADDITION:
      'ACTIVE_INACTIVE_CAFE_FACTOR_ADDITION',
    DELETE_CAFE_FACTOR_ADDITION: 'DELETE_CAFE_FACTOR_ADDITION',
    ADD_NEW_CAFE_FACTOR_ADDITION: 'ADD_NEW_CAFE_FACTOR_ADDITION',
    ACTIVE_INACTIVE_CAFE_FACTOR_DEDUCTION:
      'ACTIVE_INACTIVE_CAFE_FACTOR_DEDUCTION',
    DELETE_CAFE_FACTOR_DEDUCTION: 'DELETE_CAFE_FACTOR_DEDUCTION',
    ADD_NEW_CAFE_FACTOR_DEDUCTION: 'ADD_NEW_CAFE_FACTOR_DEDUCTION',
    VIEW_MENU_CATEGORIES_LIST: 'VIEW_MENU_CATEGORIES_LIST',
    VIEW_DELETED_MENU_CATEGORIES_LIST: 'VIEW_DELETED_MENU_CATEGORIES_LIST',
    VIEW_MENU_CATEGORY_DETAILS: 'VIEW_MENU_CATEGORY_DETAILS',
    ADD_NEW_MENU_CATEGORY: 'ADD_NEW_MENU_CATEGORY',
    ACTIVE_INACTIVE_MENU_CATEGORY: 'ACTIVE_INACTIVE_MENU_CATEGORY',
    EDIT_MENU_CATEGORY: 'EDIT_MENU_CATEGORY',
    DELETE_MENU_CATEGORY: 'DELETE_MENU_CATEGORY',
    VIEW_MENU_ITEMS_LIST: 'VIEW_MENU_ITEMS_LIST',
    VIEW_DELETED_MENU_ITEMS_LIST: 'VIEW_DELETED_MENU_ITEMS_LIST',
    VIEW_MENU_ITEM_DETAILS: 'VIEW_MENU_ITEM_DETAILS',
    ADD_NEW_MENU_ITEM: 'ADD_NEW_MENU_ITEM',
    EDIT_MENU_ITEM: 'EDIT_MENU_ITEM',
    DELETE_MENU_ITEM: 'DELETE_MENU_ITEM',
    EDIT_COMMENT: 'EDIT_COMMENT',
    SEND_NEW_MESSAGE: 'SEND_NEW_MESSAGE',
    EDIT_MESSAGE: 'EDIT_MESSAGE',
    VIEW_MESSAGES_LIST: 'VIEW_MESSAGES_LIST',
    VIEW_MESSAGE_DETAILS: 'VIEW_MESSAGE_DETAILS',
    VIEW_CAFE_TIME_SLICES_LIST: 'VIEW_CAFE_TIME_SLICES_LIST',
    ADD_NEW_CAFE_TIME_SLICE: 'ADD_NEW_CAFE_TIME_SLICE',
    VIEW_CAFE_TABLES_LIST: 'VIEW_CAFE_TABLES_LIST',
    VIEW_CAFE_TIME_SLICE_DETAILS: 'VIEW_CAFE_TIME_SLICE_DETAILS',
    VIEW_CAFE_DATES_LIST: 'VIEW_CAFE_DATES_LIST',
    VIEW_CAFE_DATES_LIST_FOR_ADMIN: 'VIEW_CAFE_DATES_LIST_FOR_ADMIN',
    ADD_NEW_CAFE_DATE: 'ADD_NEW_CAFE_DATE',
    VIEW_CAFE_DATE_DETAILS: 'VIEW_CAFE_DATE_DETAILS',
    EDIT_CAFE_TIME_SLICE: 'EDIT_CAFE_TIME_SLICE',
    EDIT_STATUS_CAFE_DATE: 'EDIT_STATUS_CAFE_DATE',
    DELETE_CAFE_DATE: 'DELETE_CAFE_DATE',
    DELETE_CAFE_TIME_SLICE: 'DELETE_CAFE_TIME_SLICE',
    EDIT_CAFE_DATE: 'EDIT_CAFE_DATE',
    VIEW_RESERVES_LIST: 'VIEW_RESERVES_LIST',
    VIEW_RESERVES_SCHEMATIC_LIST: 'VIEW_RESERVES_SCHEMATIC_LIST',
    VIEW_RESERVE_DETAILS: 'VIEW_RESERVE_DETAILS',
    EDIT_STATUS_RESERVE: 'EDIT_STATUS_RESERVE',
    VIEW_INVOICE_DETAILS: 'VIEW_INVOICE_DETAILS',
    EDIT_INVOICE: 'EDIT_INVOICE',

    ADD_NEW_CAFE_USER: 'ADD_NEW_CAFE_USER',
    VIEW_CAFE_USER_DETAILS: 'VIEW_CAFE_USER_DETAILS',
    EDIT_CAFE_USER: 'EDIT_CAFE_USER',
    DELETE_CAFE_USER: 'DELETE_CAFE_USER',

    VIEW_ADMIN_DASHBOARD_REPORTS: 'VIEW_ADMIN_DASHBOARD_REPORTS',

    VIEW_DISCOUNT_CODES_LIST: 'VIEW_DISCOUNT_CODES_LIST',
    ADD_NEW_DISCOUNT_CODE: 'ADD_NEW_DISCOUNT_CODE',
    VIEW_DISCOUNT_CODE_DETAILS: 'VIEW_DISCOUNT_CODE_DETAILS',
    EDIT_STATUS_DISCOUNT_CODE: 'EDIT_STATUS_DISCOUNT_CODE',
    EDIT_DISCOUNT_CODE: 'EDIT_DISCOUNT_CODE',

    AUTO_GENERATE_RESERVE_DATES_AND_HOURS:
      'AUTO_GENERATE_RESERVE_DATES_AND_HOURS',

    VIEW_TICKETS_LIST: 'VIEW_TICKETS_LIST',
    VIEW_TICKET_DETAILS: 'VIEW_TICKET_DETAILS',
    VIEW_MY_CAFE_WORKING_HOURS: 'VIEW_MY_CAFE_WORKING_HOURS',
    VIEW_MY_CAFE_DISCOUNTS_LIST: 'VIEW_MY_CAFE_DISCOUNTS_LIST',
    ADD_NEW_CAFE_DISCOUNT_REQUEST: 'ADD_NEW_CAFE_DISCOUNT_REQUEST',
    VIEW_ROLES_LIST: 'VIEW_ROLES_LIST',
    EDIT_CAFE_FOR_CAFE_ADMIN: 'EDIT_CAFE_FOR_CAFE_ADMIN',
    VIEW_CAFE_FOR_CAFE_ADMIN_DETAILS: 'VIEW_CAFE_FOR_CAFE_ADMIN_DETAILS',
    UPLOAD_CAFE_IMAGES: 'UPLOAD_CAFE_IMAGES',

    VIEW_ARCHIVE_RESERVES_FOR_ADMIN: 'VIEW_ARCHIVE_RESERVES_FOR_ADMIN',
    VIEW_REQUESTS_RESERVES_FOR_ADMIN: 'VIEW_REQUESTS_RESERVES_FOR_ADMIN',
    VIEW_AHEAD_RESERVES_FOR_ADMIN: 'VIEW_AHEAD_RESERVES_FOR_ADMIN',

    VIEW_CAFE_DISCOUNTS_REQUESTED_LIST: 'VIEW_CAFE_DISCOUNTS_REQUESTED_LIST',
    VIEW_CAFE_DISCOUNTS_ARCHIVED_LIST: 'VIEW_CAFE_DISCOUNTS_ARCHIVED_LIST',
    CONFIRM_CAFE_DISCOUNT: 'CONFIRM_CAFE_DISCOUNT',
    REJECT_CAFE_DISCOUNT: 'REJECT_CAFE_DISCOUNT',

    VIEW_CAFE_WORKING_HOURS: 'VIEW_CAFE_WORKING_HOURS',
    VIEW_RSEE_DISCOUNTS_LIST: 'VIEW_RSEE_DISCOUNTS_LIST',
    ADD_NEW_RSEE_DISCOUNT: 'ADD_NEW_RSEE_DISCOUNT',
    CONFIRM_RSEE_DISCOUNT: 'CONFIRM_RSEE_DISCOUNT',
    VIEW_CAFE_ADMIN_DASHBOARD_REPORTS: 'VIEW_CAFE_ADMIN_DASHBOARD_REPORTS',

    VIEW_MY_CAFE_EVENTS_LIST: 'VIEW_MY_CAFE_EVENTS_LIST',
    ADD_NEW_CAFE_EVENT_REQUEST: 'ADD_NEW_CAFE_EVENT_REQUEST',
    EDIT_CAFE_EVENT_REQUEST: 'EDIT_CAFE_EVENT_REQUEST',
    VIEW_CAFE_EVENT_DETAILS: 'VIEW_CAFE_EVENT_DETAILS',
    VIEW_CAFE_EVENTS_REQUESTED_LIST: 'VIEW_CAFE_EVENTS_REQUESTED_LIST',
    VIEW_CAFE_EVENTS_ARCHIVED_LIST: 'VIEW_CAFE_EVENTS_ARCHIVED_LIST',
    CONFIRM_CAFE_EVENT: 'CONFIRM_CAFE_EVENT',
    REJECT_CAFE_EVENT: 'REJECT_CAFE_EVENT',
    DISABLE_CAFE_EVENT: 'DISABLE_CAFE_EVENT',

    VIEW_RESERVES_READY_TO_CHECKOUT_LIST:
      'VIEW_RESERVES_READY_TO_CHECKOUT_LIST',
    VIEW_RESERVES_RELATED_TO_CAFE_FOR_CHECKOUT_LIST:
      'VIEW_RESERVES_RELATED_TO_CAFE_FOR_CHECKOUT_LIST',
    VIEW_CHECKOUTS_WITH_CAFE_LIST_ARCHIVES:
      'VIEW_CHECKOUTS_WITH_CAFE_LIST_ARCHIVES',
    VIEW_RESERVES_RELATED_TO_CHECKOUT_WITH_CAFE_LIST:
      'VIEW_RESERVES_RELATED_TO_CHECKOUT_WITH_CAFE_LIST',
    CHECKOUT_WITH_CAFE: 'CHECKOUT_WITH_CAFE',
    NEW_CHECKOUT_WITH_CAFE: 'NEW_CHECKOUT_WITH_CAFE',
    VIEW_CHECKOUTS_WITH_CAFE_LIST: 'VIEW_CHECKOUTS_WITH_CAFE_LIST',
    VIEW_CHECKOUT_WITH_CAFE_DETAILS: 'VIEW_CHECKOUT_WITH_CAFE_DETAILS',
    VIEW_ADS_LIST: 'VIEW_ADS_LIST',
    NEW_AD: 'NEW_AD',
    UPDATE_IS_VISIBLE_AD: 'UPDATE_IS_VISIBLE_AD',
    DELETE_AD: 'DELETE_AD',

    VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN:
      'VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_ADMIN',
    VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_CAFE_ADMIN:
      'VIEW_CHECKOUTS_WITH_CAFE_LIST_FOR_CAFE_ADMIN',
    AUTO_GENERATE_RESERVE_DATES_AND_HOURS_FOR_ALL_CAFES:
      'AUTO_GENERATE_RESERVE_DATES_AND_HOURS_FOR_ALL_CAFES',

    REPLY_COMMENT_BY_RSEE_USER: 'REPLY_COMMENT_BY_RSEE_USER',
    REPLY_COMMENT_BY_CAFE_USER: 'REPLY_COMMENT_BY_CAFE_USER',
    CONFIRM_OR_REJECT_COMMENT: 'CONFIRM_OR_REJECT_COMMENT',

    VIEW_USER_MOBILE_NUMBER: 'VIEW_USER_MOBILE_NUMBER',
    SEARCH_CAFE_NAMES: 'SEARCH_CAFE_NAMES',

    UPDATE_IS_DEFAULT_AD: 'UPDATE_IS_DEFAULT_AD',
    VIEW_CAFE_CONTRACTS_LIST: 'VIEW_CAFE_CONTRACTS_LIST',
    CAFE_CONTRACTS_CAFES_LIST: 'CAFE_CONTRACTS_CAFES_LIST',
    VIEW_CAFE_CONTRACT_DETAILS: 'VIEW_CAFE_CONTRACT_DETAILS',
    NEW_CAFE_CONTRACT: 'NEW_CAFE_CONTRACT',
    UPDATE_CAFE_CONTRACT: ' UPDATE_CAFE_CONTRACT',
    SALES_REPORT: 'SALES_REPORT',
    VIEW_PRINTERS_LIST: 'VIEW_PRINTERS_LIST',

    UPDATE_PRINTER: 'UPDATE_PRINTER',
    VIEW_PRINTER_DETAILS: 'VIEW_PRINTER_DETAILS',

    VIEW_CAFE_SCHEDULES_LIST: 'VIEW_CAFE_SCHEDULES_LIST',
    ADD_NEW_CAFE_SCHEDULE: 'ADD_NEW_CAFE_SCHEDULE',
    VIEW_CAFE_SCHEDULE_DETAILS: 'VIEW_CAFE_SCHEDULE_DETAILS',
    EDIT_CAFE_SCHEDULE: 'EDIT_CAFE_SCHEDULE',
    DELETE_CAFE_SCHEDULE: 'DELETE_CAFE_SCHEDULE',
    VIEW_REPORT_OF_COMPLETED_RESERVES_AND_NO_VISITS: 'VIEW_REPORT_OF_COMPLETED_RESERVES_AND_NO_VISITS',
    VIEW_TAKEAWAY_FACTORS_LIST: 'VIEW_TAKEAWAY_FACTORS_LIST',
    ADD_NEW_RSEE_PACKAGE: 'ADD_NEW_RSEE_PACKAGE',
    VIEW_RSEE_PACKAGES_LIST: 'VIEW_RSEE_PACKAGES_LIST',
    VIEW_RSEE_PACKAGE_DETAILS: 'VIEW_RSEE_PACKAGE_DETAILS',
    EDIT_RSEE_PACKAGE: 'EDIT_RSEE_PACKAGE',
    EDIT_RSEE_PACKAGE_STATUS: 'EDIT_RSEE_PACKAGE_STATUS',
    VIEW_RSEE_PACKAGES_SALES_REPORT: 'VIEW_RSEE_PACKAGES_SALES_REPORT',
    VIEW_CONSTANT_RESERVES_REPORT: 'VIEW_CONSTANT_RESERVES_REPORT',
    VIEW_RECHARGE_CHAIRS_REPORT: 'VIEW_RECHARGE_CHAIRS_REPORT',
    ADD_GIFT_CHAIR: 'ADD_GIFT_CHAIR',
    VIEW_CITIES_LIST: 'VIEW_CITIES_LIST',
    ADD_NEW_CITY: 'ADD_NEW_CITY',
    VIEW_CITY_DETAILS: 'VIEW_CITY_DETAILS',
    EDIT_CITY: 'EDIT_CITY',
    VIEW_REGIONS_LIST: 'VIEW_REGIONS_LIST',
    ADD_NEW_REGION: 'ADD_NEW_REGION',
    VIEW_REGION_DETAILS: 'VIEW_REGION_DETAILS',
    EDIT_REGION: 'EDIT_REGION',
  },
};
